var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-flex"},[_c('carrierAnalysed',{staticStyle:{"width":"250px"},attrs:{"carrierList":_vm.carrierList}}),_c('AnalysisPanel',{staticClass:"analysis-panel-wrapper"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }